import { SecondaryButton } from 'approot/shared/styles/buttons/secondary-button.style';
import ComponentAltTextLabel from './component-alt-text-label';

type Props = {
  hasAltText: boolean;
  onClick: () => void;
};

const ComponentAltTextButton = ({ hasAltText, onClick }: Props) => (
  <SecondaryButton
    type="button"
    $withIcon
    $isSmall
    aria-label={hasAltText ? 'Alt Text added' : 'Add Alt Text'}
    onClick={onClick}
    data-selector={hasAltText ? 'update-alt-text' : 'add-alt-text'}
  >
    <ComponentAltTextLabel isShortLabel hasAltText={hasAltText} />
  </SecondaryButton>
);

export default ComponentAltTextButton;
